module.exports = __webpack_public_path__ + "static/media/dataJS.8b046337.txt";